<div [class]="!isMobile ? 'booble-backdrop' : ''">
  <div [class]="!isMobile ? 'xp-modal xp-modal-cadastro' : ''">
    <div
      [class]="
        !isMobile
          ? 'modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm'
          : ''
      "
    >
      <div class="modal-content">
        <div [class]="!isMobile ? 'modal-dialog-scrollable-general' : ''">
          <div class="modal-header">
            <div
              class="col-md-12 d-flex justify-content-between modal-header-border"
            >
              <div>
                <div class="modal-title-new">Informações para o pagamento</div>
                <p class="p-text-grey font-weight-300 mg-top-8">
                  Escolha entre PIX ou TED para efetivar seu envio ou envie o
                  comprovante de pagamento caso já tenha realizado.
                </p>
              </div>

              <div
                (click)="closeModal()"
                class="close-icon tappable align-self-center"
              >
                <img src="assets/image/close-modal-icon.svg" />
              </div>
            </div>
          </div>

          <div [class]="isMobile ? '' : 'modal-body'">
            <div class="container-modal mg-top-24">
              <span class="text-choice mg-top-16">
                Escolha entre PIX ou TED.
              </span>

              <mat-radio-group
                class="mg-top-16 radios-btns"
                [(ngModel)]="paymentType"
                aria-label="Selecione uma opção"
              >
                <mat-radio-button value="PIX">
                  <p class="p-text-grey">PIX</p>
                </mat-radio-button>
                <mat-radio-button value="TED">
                  <p class="p-text-grey">TED</p>
                </mat-radio-button>
              </mat-radio-group>

              <ng-container *ngIf="paymentType == 'PIX'">
                <div class="box-modal">
                  <div class="mg-bottom-8 d-flex justify-content-between">
                    <span class="text-choice"
                      >Chave PIX:
                      <span class="text-pix">financeiro@ozcambio.com.br</span>
                    </span>
                    <img
                      class="copy"
                      (click)="copyText('financeiro@ozcambio.com.br')"
                      src="assets/image/copy-outline.svg"
                    />
                  </div>

                  <div>
                    <span class="text-choice"
                      >Valor a ser transferido:
                      <span class="text-pix">{{
                        boobleModalData?.quotations[0]?.amountMN | brl
                      }}</span>
                    </span>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="paymentType == 'TED'">
                <p class="p-text-grey font-weight-300 mg-bottom-32 mg-top-32">
                  Utilize as informações abaixo para realizar a transferência
                  via TED.
                </p>

                <div class="box-modal">
                  <div class="mg-bottom-8 d-flex justify-content-between">
                    <span class="text-choice"
                      >Nome:
                      <span class="text-pix">OZ Corretora de Câmbio S.A</span>
                    </span>
                    <img
                      class="copy"
                      src="assets/image/copy-outline.svg"
                      (click)="copyText('OZ Corretora de Câmbio S.A')"
                    />
                  </div>

                  <div class="mg-bottom-8 d-flex justify-content-between">
                    <span class="text-choice"
                      >CNPJ: <span class="text-pix">04.062.902/0001-03</span>
                    </span>
                    <img
                      class="copy"
                      (click)="copyText('04.062.902/0001-03')"
                      src="assets/image/copy-outline.svg"
                    />
                  </div>

                  <div class="mg-bottom-8">
                    <span class="text-choice"
                      >Banco:
                      <span class="text-pix"
                        >296 - OZ Corretora de Câmbio S.A</span
                      >
                    </span>
                  </div>

                  <div class="mg-bottom-8 d-flex justify-content-between">
                    <span class="text-choice"
                      >Agência: <span class="text-pix">0001</span>
                    </span>
                    <img
                      class="copy"
                      (click)="copyText('0001')"
                      src="assets/image/copy-outline.svg"
                    />
                  </div>

                  <div class="mg-bottom-8 d-flex justify-content-between">
                    <span class="text-choice"
                      >Conta: <span class="text-pix">406290-2</span>
                    </span>
                    <img
                      class="copy"
                      (click)="copyText('406290-2')"
                      src="assets/image/copy-outline.svg"
                    />
                  </div>

                  <div>
                    <span class="text-choice"
                      >Valor a ser transferido:
                      <span class="text-pix">{{
                        boobleModalData?.quotations[0]?.amountMN | brl
                      }}</span>
                    </span>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="individualId">
                <div class="row">
                  <div class="col">
                    <div class="col-individual-warning">
                      <div class="d-flex justify-content-between margin-mb-16">
                        <div class="d-flex gap-10">
                          <img src="assets/image/information-icon.svg" />

                          <p class="text-p">
                            <strong class="weight-500"
                              >Apenas conta bancária de propriedade do
                              titular</strong
                            >
                          </p>
                        </div>
                      </div>

                      <p class="text-p text-information">
                        Lembramos que o pagamento do valor para envio deve ser
                        realizado exclusivamente a partir da conta bancária de
                        propriedade do CPF cadastrado.
                      </p>
                    </div>
                  </div>
                </div>
              </ng-container>

              <p
                *ngIf="companyId"
                [class]="isMobile ? 'order-payment-mobile' : 'mg-top-32'"
                class="p-text-grey font-weight-300"
              >
                Lembramos que o pagamento do valor para envio deve ser realizado
                exclusivamente a partir da conta jurídica de propriedade do CNPJ
                cadastrado.
              </p>
            </div>
          </div>
        </div>

        <div class="modal-footer-new">
          <button
            type="button"
            (click)="openAttachInvoiceModal(boobleModalData)"
            class="btn-footer btn btn-block"
            [ngClass]="
              companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
            "
            type="button"
          >
            Enviar o comprovante do pagamento
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
